export const getMinDate = () => {
    const today = new Date();
    return new Date(today.setFullYear(today.getFullYear() - 18));
  };